<template>
    <div id="app">
        <v-app id="inspire">
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="60">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">NEW MECHANIC</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout>
                </v-container>
            </v-parallax>

            <v-layout row justify-center>
                <v-card>
                <v-card-text>
                    <form>
                    <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-autocomplete v-model="mechanicBranch"  label="Branch*" :items="activeBranches" persistent-hint prepend-icon="domain" hide-no-data clearable leave-absolute>
                                <template v-slot:append-outer>
                                    <v-slide-x-reverse-transition mode="out-in">
                                    </v-slide-x-reverse-transition>
                                </template>
                            </v-autocomplete>
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field label="Name*" v-model='mechanicName' prepend-icon="perm_identity" required></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field label="E-mail" v-model='mechanicEmail' prepend-icon="mail_outline" required :rules="emailRules"></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                            <v-checkbox v-model="tag" label="Visible to Customer"></v-checkbox>
                        </v-flex>

                        <v-flex xs12>
                            <v-radio-group v-model="mechanicStatus" :mandatory="false" row>
                                <v-radio label="Active" color="success" value="Active"></v-radio>
                                <v-radio label="Disabled" color="orange darken-4" value="In-active"></v-radio>
                            </v-radio-group>
                        </v-flex>

                    </v-layout>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue-grey" dark @click='$router.push("/branch-mechanic-management")'>CANCEL</v-btn>
                        <v-btn color="red accent-4" dark @click="saved()">SAVE</v-btn>
                    </v-card-actions>
                    </v-container>
                    </form>
                </v-card-text>
                </v-card>
            </v-layout>

            <v-dialog v-model="showProgress" persistent width="300">
                <v-card  color="primary">
                    <v-card-text class="subheading white--text">{{progressMessage}}
                        <v-layout row justify-center>
                        <v-progress-linear :indeterminate="true" v-if="showProgress"
                            :size="70"
                            :width="5"
                            color="white"
                        ></v-progress-linear>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-snackbar v-model="showSnackBar" bottom right :color="snackbarColor" :timeout=3000>
                    {{snackbarMessage}}
                <v-btn dark small flat @click="showSnackBar = false">Close</v-btn>
            </v-snackbar>

        </v-app>
    </div>
</template>

<script>
import firebase from "firebase";
import firebaseui from "firebaseui";
import "../../node_modules/firebaseui/dist/firebaseui.css";
import { config } from "../firebaseConfig";
import router from '../router';
import { db } from '../main.js'
import { storage } from '../main.js'
import { mapGetters, mapActions } from "vuex";
import store from '../stores'
import moment from 'moment'
import _ from 'lodash';
export default {
    data() {
        return {
            mechanicName: "",
            mechanicEmail: "",
            mechanicBranch: "",
            mechanicStatus: "Active",
            mechanicTime: ["09:00AM", "09:30AM", "10:00AM", "10:30AM", "11:00AM", "11:30AM", "01:00PM", "01:30PM", "02:00PM", "02:30PM", "03:00PM", "03:30PM", "04:00PM"],
            service: "",
            description: "",
            price: "",
            imgsrc: "",
            flatrate: [],
            snackbarMessage: "",
            progressMessage: "",
            snackbarColor: "",
            showProgress: false,
            showSnackBar: false,
            branches: [],
            activeBranches: [],
            emailRules: [ v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            tag: false,
        }
    },

    mounted() {
       this.fetchBranches()
    },

    methods: {
        async fetchBranches() {
            var self = this;

            self.branches = []
            self.activeBranches= [],

            await db.collection("BusinessUnits"+self.$stage)
            .onSnapshot(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                   self.branches.push(doc.data())
                })

                self.branches.forEach(function(unit){
                    if(unit.Status == "Active") {
                        self.activeBranches.push(unit.BusinessUnit)
                    }

                });
            })
        },

        saved() {
            let self = this;
            if(self.mechanicName  != "" && self.mechanicBranch != "") {
                self.progressMessage="Adding new service"
                self.showProgress=true;
                db.collection("Mechanics"+self.$stage).doc(self.mechanicName).set({
                    name: self.mechanicName,
                    email: self.mechanicEmail,
                    branch: self.mechanicBranch,
                    time: self.mechanicTime,
                    tag: self.tag,
                    status: self.mechanicStatus
                })
                .then(function() {
                    self.showProgress=false
                    self.snackbarMessage = "Successfully added" 
                    self.snackbarColor = "success"
                    self.showSnackBar= true
                    setTimeout(() => {
                        self.goToPage("branch-mechanic-management")
                    }, 1500);
                })
            } else {
                self.snackbarMessage = "Please fill up all details"
                self.snackbarColor = "error"
                self.showSnackBar = true
            }
        },


        goToPage(page) {
            this.$router.push("/"+page)
        },
    },

    computed : {
        ...mapGetters(["user"]),
    },

    watch: {

    }
}
</script>

<style scoped>

</style>




